module.exports = "/cyber/_next/static/images/loginSteamMobile-7600770285adeaa65a3b4b60ac99c75f.jpg";